import InputCreator, {
  TInputCreatorProps,
} from '~/components/atoms/FormControls/InputCreator';

export type TInputProps = TInputCreatorProps<JSX.IntrinsicElements['input']>;
export default InputCreator<TInputProps, HTMLInputElement>('input');
